var map = {
	"./Ellipse.webp": 7758,
	"./Excel.webp": 6441,
	"./FlashCharger.webp": 4405,
	"./Flowers-right.webp": 3438,
	"./Keeley.webp": 8186,
	"./Lydia.webp": 4955,
	"./LydiaWithClient.webp": 5769,
	"./TaylorTaylorHair.webp": 7076,
	"./circle.webp": 5109,
	"./circleDesktop.webp": 349,
	"./contact-form-shape-mobile.webp": 7619,
	"./contact-form-shape.webp": 9016,
	"./dan.webp": 5071,
	"./duoShapes.webp": 1531,
	"./facebook-icon.webp": 5191,
	"./flowers-left.webp": 2527,
	"./flowers1.webp": 6931,
	"./flowers2.webp": 7593,
	"./flowersDesktop.webp": 221,
	"./flowersDesktop_bottom.webp": 3531,
	"./green-eclipse.webp": 7000,
	"./hayley.webp": 8469,
	"./icons/Blog.webp": 3523,
	"./icons/Copywriting.webp": 8433,
	"./icons/PodcastIcon.webp": 720,
	"./icons/PressRelease.webp": 8878,
	"./icons/SEO.webp": 2000,
	"./icons/SMSMarketing.webp": 9700,
	"./icons/SocialMediaAds.webp": 2142,
	"./icons/SocialMediaMarketing.webp": 2016,
	"./instagram-logo.webp": 972,
	"./logo.webp": 2781,
	"./lydia-cartoon-desktop-edit.webp": 2184,
	"./lydia-cartoon.webp": 370,
	"./paul.webp": 1154,
	"./pink-eclipse.webp": 1421,
	"./sheffield-dog-training.webp": 4362,
	"./steven.webp": 1393,
	"./sunflower.webp": 2418,
	"./twitter-logo.webp": 121,
	"./yellow-dashes.webp": 4633,
	"./zigzag.webp": 8019
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;